import { CAD_TYPES } from '../../CAD.types';

export function getTypeIcon({ type }: { type: CAD_TYPES }): string {
	switch (type) {
		case CAD_TYPES.TEXT: {
			return 'talend-text';
		}
		case CAD_TYPES.LIST_OF_VALUES: {
			return 'talend-list';
		}
		default:
			return '';
	}
}

export function getTypeLabel(t: Function, type: CAD_TYPES): string {
	switch (type) {
		case CAD_TYPES.TEXT: {
			return t('CAD_LIST_TYPE_TEXT', { defaultValue: 'Text' }) as string;
		}
		case CAD_TYPES.LIST_OF_VALUES: {
			return t('CAD_LIST_TYPE_ENUM', { defaultValue: 'List of values' }) as string;
		}
		default:
			return '';
	}
}

export function getColumns(t: Function): any {
	return {
		label: {
			label: t('CAD_LIST_NAME', {
				defaultValue: 'Name',
			}),
			dataKey: 'label',
		},
		description: {
			label: t('CAD_LIST_DESCRIPTION', {
				defaultValue: 'Description',
			}),
			dataKey: 'description',
		},
		type: {
			label: t('CAD_LIST_TYPE', {
				defaultValue: 'Type',
			}),
			dataKey: 'typeLabel',
		},
		mandatory: {
			label: t('CAD_LIST_MANDATORY', {
				defaultValue: 'Mandatory',
			}),
			dataKey: 'mandatory',
		},
		createdAt: {
			label: t('CAD_LIST_CREATED_ON', {
				defaultValue: 'Created on',
			}),
			dataKey: 'createdAt',
		},
		createdBy: {
			label: t('CAD_LIST_CREATED_BY', {
				defaultValue: 'Created by',
			}),
			dataKey: 'createdBy',
		},
		updatedAt: {
			label: t('CAD_LIST_MODIFIED_ON', {
				defaultValue: 'Modified on',
			}),
			dataKey: 'updatedAt',
		},
		updatedBy: {
			label: t('CAD_LIST_MODIFIED_BY', {
				defaultValue: 'Modified by',
			}),
			dataKey: 'updatedBy',
		},
	};
}

export function getExpandedSortOptions(t: Function): { label: string; key: string }[] {
	return [
		{
			label: t('CAD_LIST_NAME', {
				defaultValue: 'Name',
			}),
			key: 'label',
		},
		{
			label: t('CAD_LIST_DESCRIPTION', {
				defaultValue: 'Description',
			}),
			key: 'description',
		},
		{
			label: t('CAD_LIST_TYPE', {
				defaultValue: 'Type',
			}),
			key: 'type',
		},
		{
			label: t('CAD_LIST_MANDATORY', {
				defaultValue: 'Mandatory',
			}),
			key: 'mandatory',
		},
		{
			label: t('CAD_LIST_CREATED_ON', {
				defaultValue: 'Created on',
			}),
			key: 'createdAt',
		},
		{
			label: t('CAD_LIST_CREATED_BY', {
				defaultValue: 'Created by',
			}),
			key: 'createdBy',
		},
		{
			label: t('CAD_LIST_MODIFIED_ON', {
				defaultValue: 'Modified on',
			}),
			key: 'updatedAt',
		},
		{
			label: t('CAD_LIST_MODIFIED_BY', {
				defaultValue: 'Modified by',
			}),
			key: 'updatedBy',
		},
	];
}
